import React, { useState } from 'react';
import styled from 'styled-components';
import { Menu, Modal, Tooltip } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUserSecret,
  faServer,
  faSignOutAlt,
  faHardHat,
  faUserCircle,
  faArchive
} from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import { Link, Redirect, useLocation } from 'react-router-dom';
import { logout } from '../../shared/utils/auth';
import useUserContext from '../../shared/hooks/useUserContext';

const { confirm } = Modal;

const IconContainer = styled.span`
  margin-right: 1vh;
`;

const LogoContainer = styled.div`
  display: flex;
  flex-direction: 'row';
  justify-content: center;
  align-items: center;
  margin: 20px 0px;
  padding: 0px 10px;
`;

const Logo = styled.img`
  height: 38px;
`;

const Bacon = styled.img`
  margin-left: 6px;
  height: 35px;
`;

const EmailContainer = styled.div`
  color: rgba(255, 255, 255, 0.65);
  margin: 15px 10px 10px 24px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: auto;
  overflow-x: hidden;
`;

const MenuGrease = () => {
  const userConsumer = useUserContext();
  const [loggedOut, setLoggedOut] = useState(false);
  let location = useLocation();

  const getUsernameToDisplay = () => {
    const MAX_CHARS = 10;
    const username = userConsumer?.user?.username;
    if (username?.length > MAX_CHARS) {
      return [`${username?.substr(0, MAX_CHARS)}...`, username];
    } else {
      return username;
    }
  };

  const logoutHandler = () => {
    confirm({
      title: 'Logout',
      content: 'Are you sure you want to logout?',
      okText: 'Yes',
      okType: 'green',
      cancelText: 'No',
      onOk () {
        logout();
        userConsumer.setUser({ accessToken: null, loggedIn: false });
        setLoggedOut(true);
      },
      onCancel () { },
    });
  };

  const selectedKey = `/${location.pathname.split('/')[1].split('-')[0]}`;

  return (
    <>
      <Menu
        selectedKeys={[selectedKey === '/' ? '/server' : selectedKey]}
        defaultSelectedKeys={['/server']}
        mode="inline"
      >
        <LogoContainer>
          <Link to="/">
            <Logo src={`${process.env.PUBLIC_URL}/images/bacon_icon.svg`} />
            <Bacon
              src={`${process.env.PUBLIC_URL}/images/grease_logo_text_white.png`}
            />
          </Link>
        </LogoContainer>
        <Menu.Divider />
        <Menu.Item key="/server">
          <Link to="/server">
            <IconContainer>
              <FontAwesomeIcon icon={faServer} color='inherit' />
            </IconContainer>
            Bacon Server
          </Link>
        </Menu.Item>
        <Menu.Item key="/agent">
          <Link to="/agent">
            <IconContainer>
              <FontAwesomeIcon icon={faUserSecret} color='inherit' />
            </IconContainer>
            Bacon Agents
          </Link>
        </Menu.Item>

        <Menu.Item key="/setup">
          <Link to="/setup">
            <IconContainer>
              <FontAwesomeIcon icon={faHardHat} color='inherit' />
            </IconContainer>
            Bacon Setup
          </Link>
        </Menu.Item>

        <Menu.Item key="/resources">
          <Link to="/resources">
            <IconContainer>
              <FontAwesomeIcon icon={faArchive} color='inherit' />
            </IconContainer>
            Resource Downloads
          </Link>
        </Menu.Item>

        <Menu.Divider />
        <div>
          <EmailContainer>
            <IconContainer>
              <FontAwesomeIcon icon={faUserCircle} color='inherit' />
            </IconContainer>
            {
              getUsernameToDisplay().length > 20 ? (<Tooltip placement={'bottomRight'} color={'inherit'} title={getUsernameToDisplay()}>
                <span>{getUsernameToDisplay()}</span>
              </Tooltip>) :  getUsernameToDisplay()
            }
          </EmailContainer>
        </div>
        <Menu.Item
          key="/logout"
          id="logout-menu-item"
          onClick={logoutHandler}
        >
          <IconContainer>
            <FontAwesomeIcon icon={faSignOutAlt} color='inherit' />
          </IconContainer>
          Logout
        </Menu.Item>
      </Menu>
      {loggedOut && <Redirect to="/login" />}
    </>);
};

MenuGrease.propTypes = {
  current: PropTypes.string,
  setCurrent: PropTypes.func,
  username: PropTypes.string,
};

export default MenuGrease;
